import React, { useMemo } from "react";
import { AlertCircle, Info, Check } from "lucide-react";
import { analyzeEmail } from "@/lib/emailSuggest";

/**
 * Inline hint shown below an <Input type="email">.
 * - Silencia quando o e-mail é válido ou está vazio.
 * - Mostra sugestão clicável para trocar automaticamente quando detecta typo.
 * - Mostra alerta suave quando o formato é suspeito mas não corrigível.
 */
export default function EmailHint({ value, onAccept, testid = "email-hint" }) {
  const result = useMemo(() => analyzeEmail(value), [value]);

  if (result.kind === "ok") return null;

  if (result.kind === "typo") {
    return (
      <div
        className="mt-1.5 flex items-start gap-2 text-xs text-amber-900 bg-amber-50 border border-amber-200 rounded-lg px-3 py-2"
        data-testid={testid}
        data-hint-kind="typo"
      >
        <AlertCircle className="h-3.5 w-3.5 shrink-0 mt-0.5 text-amber-600" />
        <div className="min-w-0 flex-1">
          <span>{result.reason}</span>{" "}
          <button
            type="button"
            onClick={() => onAccept?.(result.suggestion)}
            className="inline-flex items-center gap-1 font-semibold text-amber-900 underline decoration-amber-500 underline-offset-2 hover:text-amber-950 break-all"
            data-testid={`${testid}-accept`}
          >
            <Check className="h-3 w-3" /> Usar {result.suggestion}
          </button>
        </div>
      </div>
    );
  }

  if (result.kind === "warning") {
    return (
      <div
        className="mt-1.5 flex items-start gap-2 text-xs text-stone-600 bg-stone-50 border border-stone-200 rounded-lg px-3 py-2"
        data-testid={testid}
        data-hint-kind="warning"
      >
        <Info className="h-3.5 w-3.5 shrink-0 mt-0.5 text-stone-500" />
        <span>{result.reason}</span>
      </div>
    );
  }

  // invalid
  return (
    <div
      className="mt-1.5 flex items-start gap-2 text-xs text-red-800 bg-red-50 border border-red-200 rounded-lg px-3 py-2"
      data-testid={testid}
      data-hint-kind="invalid"
    >
      <AlertCircle className="h-3.5 w-3.5 shrink-0 mt-0.5 text-red-600" />
      <span>{result.reason}</span>
    </div>
  );
}
